import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import useUIContext from '~/ui/use-ui-context';
import { Context } from '~/ui/ui-context';

const QueryEncodedRoutesFactory = (routeCodecs: Context[]) => {
	const QueryEncodedRoutes = ({ children }: { children: React.ReactElement<unknown> }) => {
		const actualLocation = useLocation();
		const decodedLocation = routeCodecs
			.map(routeCodec => [routeCodec.queryDecoder(actualLocation)])
			.map(([responsiveLocation]) => responsiveLocation)
			.find(Boolean);

		if (!decodedLocation) return null;

		return (
			<TracedRoutes
				location={{
					...decodedLocation,
					state: {
						...(actualLocation.state ? (actualLocation.state as Record<string, unknown>) : {})
					} // TODO (navigation) - remove react router state
				}}
			>
				{children}
			</TracedRoutes>
		);
	};

	return QueryEncodedRoutes;
};

const ContextAwareRoutes = ({ children }: { children: React.ReactElement<unknown> }) => {
	const { within, contexts } = useUIContext();
	const MemoizedRoutes = useMemo(
		() => QueryEncodedRoutesFactory(contexts.filter(({ key }) => key === within)),
		[within, contexts]
	);
	return <MemoizedRoutes>{children}</MemoizedRoutes>;
};

export default ContextAwareRoutes;
